import Big from 'big.js'

 
export class NumberFormatter {
  static roundToString (amount: number | undefined | null, precision: number): string {
    if (amount === undefined) return ''
    if (amount === null) return ''

    return new Big(amount)
      .round(precision)
      .toFixed(precision)
  }

  static formatWithThousandsSeparator (amount: number, precision: number): string {
    if (Math.abs(amount) > 1000) {
      return this.roundToString(amount, precision).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } else {
      return this.roundToString(amount, precision)
    }
  }
}
